import ViewCell from "../ui/ViewCell/ViewCell";

export const renderFieldByType = ({
  isEditable,
  setIsEditable,
  cellDisplayType,
  fieldProps,
  fieldComponent,
}) => {
  if (isEditable && fieldComponent) {
    return <td>{fieldComponent}</td>;
  }

  return <ViewCell
    cellDisplayType={cellDisplayType}
    isEditable={isEditable}
    setIsEditable={setIsEditable}
    {...fieldProps}
  />
};
